<div class="card-container" [style.backgroundColor]="partnerLessonCard.color">
    <div class="card-format" [style.height.px]="cardSizeScaled">
        <div class="card-content-container" fxLayout="column" [style.transform]="scaleCard" (click)="goToInfo()">

          <div class="card-date" *ngIf="partnerLessonCard.month!=null || partnerLessonCard.month!=''">
            <div>{{ partnerLessonCard.month }}</div>
        </div>
        <div fxFlex></div>
            <div class="card-title" [matTooltip]="partnerLessonCard.name">
                <div>{{ partnerLessonCard.name }}</div>
            </div>
            <div fxFlex></div>
            <div class="card-category-description">
                <a>
                    <div>{{ partnerLessonCard.description }}</div>
                </a>
            </div>
            <div fxFlex></div>
            <!--  <mat-chip-list class="card-tag-container">
          <mat-chip class="card-tag" *ngFor="let tag of lessonCardInfo.tags" [style.color]="lessonCardInfo.color">
            {{ tag }}
          </mat-chip>
        </mat-chip-list> -->
            <div class="card-category">{{ partnerLessonCard.category }}</div>
            <div fxFlex></div>
            <div class="card-scene" fxLayout="row" fxLayoutAlign="left center" fxLayoutGap="1em">
            
        <div fxFlex (click)="goToInfo()"></div>
        <!-- <div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button">
          <mat-icon>smartphone</mat-icon>
        </div> -->
        <!--div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button">
          <mat-icon (click)="onVisibility()" matTooltip="{{lessonCardInfo.isPublic ? 'Publica':'Privada'}}">
            {{lessonCardInfo.isPublic ? 'visibility':'visibility_off'}}
          </mat-icon>
        </div-->
    </div>
</div>
